import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-081e040b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "field" }
const _hoisted_2 = { class: "input-wrapper" }
const _hoisted_3 = { class: "icon" }
const _hoisted_4 = ["for"]
const _hoisted_5 = {
  key: 0,
  class: "validation-message"
}

import {
  ref,
  watch,
  PropType,
  computed,
  onUpdated,
  onRenderTracked,
  onBeforeMount,
  onActivated,
  onMounted
} from 'vue';
import Calendar from 'primevue/calendar';


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomCalendarField',
  props: {
  modelValue: String,
  id: String,
  placeholder: String,
  iconClass: String,
  validators: Array as PropType<Array<(value: string) => boolean>>,
  validationMessage: String
},
  emits: ['update:modelValue', 'update:isValid'],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const value = ref(props.modelValue);

const delayed = ref(true);
const isValid = computed(() => {
  if (delayed.value) return true;
  if (!props.validators) return true;
  return props.validators.every((validator) => validator(props.modelValue!));
});

onMounted(() => {
  document
    .querySelectorAll('.form-input > input')[0]
    .setAttribute('style', 'border: 0px solid red;');
  setTimeout(() => {
    delayed.value = false;
  }, 500);
});

watch(
  () => props.modelValue,
  (newValue) => {
    value.value = newValue;
  }
);

watch(value, (newValue) => {
  emit('update:modelValue', newValue);
});

watch(isValid, (newValue) => {
  emit('update:isValid', {
    fieldName: props.id,
    isValid: newValue
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, [
        _createElementVNode("i", {
          class: _normalizeClass(__props.iconClass && __props.iconClass)
        }, null, 2)
      ]),
      (__props.placeholder)
        ? (_openBlock(), _createElementBlock("label", {
            key: 0,
            for: __props.id,
            class: "tag"
          }, _toDisplayString(__props.placeholder), 9, _hoisted_4))
        : _createCommentVNode("", true),
      _createVNode(_unref(Calendar), {
        id: __props.id,
        modelValue: value.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
        placeholder: __props.placeholder,
        class: _normalizeClass(['form-input', { 'input-error': !isValid.value }])
      }, null, 8, ["id", "modelValue", "placeholder", "class"])
    ]),
    (!isValid.value)
      ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(__props.validationMessage), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})